import { createRouter, createWebHashHistory } from "vue-router";
// import axios from "axios";
// import Swal from "sweetalert2";
// import version from '@/version.json'
// import HomeView from '../views/HomeView.vue'

const routes = [
    {
        path: "/",
        name: "Dashboard",
        // component: () => import(/* webpackChunkName: "about" */ '../views/Project/ProjectList.vue')
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/mainPage.vue"),
    },

    {
        path: "/Login",
        name: "Login",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/UserLogin.vue"),
    },
    {
        path: "/404",
        name: "404",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/404page.vue"),
    },
    // Catch all route - must be last
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/404page.vue"),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// async function checkAppNewVersion() {
//     const url = `version.json?t=${Date.now()}`;
//     let res = null;
//     try {
//         res = await axios.get(url);
//     } catch (err) {
//         console.error("checkAppNewVersion error: ", err);
//     }

//     if (!res) return;
//     const version = res.data.version;
//     const localVersion = localStorage.getItem("version");

//     if (!localVersion) {
//         localStorage.setItem("version", version);
//     } else {
//         if (version != localVersion) {
//             localStorage.setItem("version", version);
//             Swal.fire(
//                 "New Version Available",
//                 "Please refresh the page to update the application",
//                 "warning"
//             ).then(() => {
//                 location.reload(true);
//             });
//         }
//     }
// }

router.beforeEach((to, from, next) => {
    // checkAppNewVersion();
    const isAuthenticated = localStorage.getItem("token");
    if (to.name !== "Login" && !isAuthenticated) {
        next({ name: "Login" });
    } else if (isAuthenticated && to.name === "Login") {
        next({ name: "Dashboard" });
    } else {
        next();
    }
});
export default router;
